import { useMutation } from '@tanstack/react-query';
import { validateToken } from '@/api/validateToken/validateToken';
import { TokenInfo } from '@/@types/validateToken';

export const useValidateToken = () => {
  const { mutate, data } = useMutation(async (payload: TokenInfo) => {
    const data = await validateToken(payload);
    return data;
  });
  return {
    validateToken: mutate,
    isTokenValid: data?.valid,
  };
};
